import { render, staticRenderFns } from "./Receptions.vue?vue&type=template&id=2def000b&lang=pug&"
import script from "./Receptions.vue?vue&type=script&lang=js&"
export * from "./Receptions.vue?vue&type=script&lang=js&"
import style0 from "./Receptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports